<template>
	<b-container class="mt-5" fluid="lg">
		<b-row>
			<b-col lg="6" offset-lg="3">
				<h2>Login</h2>
				<b-card>
					<validation-observer ref="observer" v-slot="{ handleSubmit }">
						<b-form v-on:submit.stop.prevent="handleSubmit( onSubmit )">

							<validation-provider v-slot="validationContext" name="Username" v-bind:rules="{ required: true }" vid="name">
								<b-form-group ref="user-username" label="Username" label-for="user-username">
									<b-form-input id="user-username" v-model="form_data.username" v-bind:state="getValidationState( validationContext )"></b-form-input>
									<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
								</b-form-group>
							</validation-provider>

							<validation-provider v-slot="validationContext" name="Password" v-bind:rules="{ required: true }" vid="password">
								<b-form-group ref="user-password" label="Password" label-for="user-password">
									<b-form-input type="password" id="user-password" v-model="form_data.password" v-bind:state="getValidationState( validationContext )"></b-form-input>
									<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
								</b-form-group>
							</validation-provider>

							<b-button block type="submit" variant="primary">Login</b-button>

						</b-form>
					</validation-observer>
				</b-card>
			</b-col>
		</b-row>
	</b-container>
</template>

<style lang="scss">
@import "src/assets/variables";
</style>

<script>
import { USER_LOGIN } from '../store/actions/user'

export default {
	name: 'Login',

	data () {
		return {
			form_data: {
				username: '',
				password: ''
			}
		}
	},

	methods: {
		getValidationState ({ dirty, validated, valid = null }) {
			return dirty || validated ? valid : null;
		},

		async onSubmit () {
			await this.$store.dispatch(USER_LOGIN, this.form_data);
			if (this.$store.state.user.isAuthenticated) {
				await this.$router.push({ name: 'create'});
			}
		}
	}
}
</script>
